import { createClient } from '@/prismicio';
import { notFound } from 'next/navigation';
import { Header } from './Header';

const HeaderWrapper = async () => {
  let page;
  try {
    const client = createClient();
    page = await client.getByType('header');
  } catch {
    return notFound();
  }
  return <Header page={page.results[0]} />;
};

export default HeaderWrapper;
